module.exports = __webpack_public_path__ + "static/img/200263.f7c860ff.png";